/**
 * Returns the current UK school term as a string, e.g. "Autumn 2025".
 *
 * Term mapping (approximate — not school-specific):
 *   Sep–Dec → Autumn
 *   Jan–Mar → Spring
 *   Apr–Aug → Summer
 */
export function getCurrentTerm(): string {
  const now = new Date();
  const month = now.getMonth() + 1; // 1–12
  const year = now.getFullYear();

  if (month >= 9) return `Autumn ${year}`;
  if (month <= 3) return `Spring ${year}`;
  return `Summer ${year}`;
}

/**
 * Extracts the season from a term string.
 * e.g. "Autumn 2025" → "Autumn"
 */
export function getTermSeason(term: string): string {
  return term.split(' ')[0];
}
